/** React hook returning a translate function bound to the current locale from the app store */

import { useCallback } from 'react'
import { useAppStore } from '../stores/app-store'
import { translate, type TranslateFn } from './translate'

export function useT(): TranslateFn {
  const locale = useAppStore((s) => s.locale)
  return useCallback<TranslateFn>((key, params) => translate(locale, key, params), [locale])
}
